import { render, staticRenderFns } from "./AddAreaDialog.vue?vue&type=template&id=ebef2626&scoped=true"
import script from "./AddAreaDialog.vue?vue&type=script&lang=js"
export * from "./AddAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAreaDialog.vue?vue&type=style&index=0&id=ebef2626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebef2626",
  null
  
)

export default component.exports